import React from "react";

function HeroHeadline() {
  return (
    <div className="hero__headline">
      <h1 className="hero__title">
        <span>Decentralized brand</span>
        <br className="hero__title-break" />
        <span>acceleration</span>
      </h1>
      <h2 className="hero__subtitle">meets symbolic tokenomics</h2>
    </div>
  );
}

export default HeroHeadline;
